(() => {
  const config = document.querySelector('meta[name="spoilt-search-brands"]');
  if (!config) return;
  const searchPath = config.dataset.searchPath;
  const indexPath = config.dataset.indexPath;
  const fold = text => String(text || '').normalize('NFKC').toLocaleLowerCase().replace(/\s+/g, ' ').trim();
  const plain = query => /^"[^"\\]+"(?: AND "[^"\\]+")*$/.test(query) ? [...query.matchAll(/"([^"]+)"/g)].map(m => m[1]).join(' ') : query;
  let products = [], filterHTML = '', ready, sequence = 0;
  async function loadCatalog() {
    if (ready) return ready;
    ready = (async () => {
      const found = [], seen = new Set();
      let url = new URL(indexPath, location.origin);
      url.searchParams.set('view', 'spoilt-search-index');
      while (url) {
        if (seen.has(url.href)) throw new Error('Repeated catalog page');
        seen.add(url.href);
        const response = await fetch(url.href, {credentials:'same-origin'});
        if (!response.ok) throw new Error('Catalog could not be loaded');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const index = doc.querySelector('[data-search-index]');
        if (!index) throw new Error('Catalog index unavailable');
        if (!filterHTML) filterHTML = doc.querySelector('[data-search-filters]')?.innerHTML || '';
        doc.querySelectorAll('[data-search-product]').forEach(template => {
          const p = {...template.dataset, html:template.innerHTML};
          p.text = fold(p.text); p.tags = JSON.parse(p.tags); p.price = Number(p.price); p.created = Number(p.created);
          found.push(p);
        });
        const next = index.dataset.next;
        url = next ? new URL(next, location.origin) : null;
        if (url) url.searchParams.set('view','spoilt-search-index');
      }
      products = found;
      return found;
    })().catch(error => { ready = null; throw error; });
    return ready;
  }
  const matchesQuery = (product, query) => fold(plain(query)).split(' ').filter(Boolean).every(term => product.text.includes(term));
  window.SpoiltSubstringCatalog = async (instance, query) => {
    const request = (instance.substringRequest || 0) + 1;
    instance.substringRequest = request;
    instance.setLiveRegionLoadingState();
    try {
      await loadCatalog();
      if (request !== instance.substringRequest || instance.getQuery() !== query || document.activeElement !== instance.input) return;
      const matches = products.filter(p => matchesQuery(p,query));
      const wrapper = document.createElement('div'); wrapper.id='predictive-search-results-groups-wrapper';wrapper.dataset.totalResults=matches.length;
      const list = document.createElement('ul');list.className='predictive-search__results-list list-unstyled';list.setAttribute('role','group');
      matches.slice(0,6).forEach((p,i) => {
        const item=document.createElement('li');item.id='substring-suggestion-'+i;item.setAttribute('role','option');item.setAttribute('aria-selected','false');
        const link=document.createElement('a');link.href=config.dataset.productPath+'/'+encodeURIComponent(p.handle);link.className='predictive-search__item link link--text';link.tabIndex=-1;
        if(p.image){const img=document.createElement('img');img.src=p.image;img.alt='';img.width=60;img.height=60;img.loading='lazy';link.append(img);}
        const title=document.createElement('span');title.textContent=p.title;link.append(title);item.append(link);list.append(item);
      });
      wrapper.append(list);
      const count=document.createElement('span');count.className='visually-hidden';count.dataset.predictiveSearchLiveRegionCountValue='';count.textContent=`${matches.length} matching products`;wrapper.append(count);
      const submit=document.createElement('button');submit.type='submit';submit.className='predictive-search__item link link--text';submit.textContent=matches.length ? `View all ${matches.length} results` : 'No matching products';wrapper.append(submit);
      instance.renderSearchResults(wrapper.outerHTML);
    } catch { instance.close(); }
  };
  const fieldValues = (product, name) => {
    if (name === 'filter.p.vendor') return [product.vendor];
    if (name === 'filter.p.tag') return product.tags;
    if (name === 'filter.p.m.custom.grade_name') return [product.grade];
    if (name === 'filter.p.m.custom.stock') return [product.stock];
    if (name === 'filter.v.t.shopify.color-pattern') return product.colors.match(/gid:\/\/shopify\/TaxonomyValue\/\d+/g) || [];
    return [];
  };
  function matchesFilters(product, params, ignore) {
    for (const name of new Set(params.keys())) {
      if (!name.startsWith('filter.') || name === ignore) continue;
      const values = params.getAll(name).filter(Boolean);
      if (!values.length) continue;
      if (name === 'filter.v.price.gte') { if (product.price < Number(values[0])) return false; }
      else if (name === 'filter.v.price.lte') { if (product.price > Number(values[0])) return false; }
      else if (!values.some(value => fieldValues(product,name).includes(value))) return false;
    }
    return true;
  }
  function paramsFromForm(form) {
    const data = new URLSearchParams(new FormData(form));
    const current = new URLSearchParams(location.search);
    if (!data.has('q')) data.set('q', current.get('q') || '');
    return data;
  }
  function ensureFilters(container) {
    let aside = document.querySelector('#main-search-filters');
    if (!aside) {
      aside = document.createElement('aside'); aside.id = 'main-search-filters'; aside.className = 'facets-wrapper page-width';
      container.before(aside);
    }
    if (!aside.dataset.substringReady) {
      aside.innerHTML = filterHTML;
      aside.dataset.substringReady = 'true';
      const sort = aside.querySelector('#SortBy');
      if (sort) sort.replaceChildren(...[['relevance','Relevance'],['price-ascending','Price, low to high'],['price-descending','Price, high to low'],['title-ascending','Alphabetically, A–Z'],['created-descending','Newest first']].map(([value,text]) => {const option = document.createElement('option'); option.value=value; option.textContent=text; return option;}));
      aside.querySelectorAll('facet-remove a').forEach(link => { link.href = searchPath + '?q=' + encodeURIComponent(plain(new URLSearchParams(location.search).get('q') || '')); });
    }
    return aside;
  }
  async function render(searchParams, event, updateHistory = true) {
    const version = ++sequence;
    const params = new URLSearchParams(searchParams);
    if (!params.has('q')) params.set('q', new URLSearchParams(location.search).get('q') || '');
    params.set('q', plain(params.get('q') || ''));
    params.delete('options[prefix]');
    if (event) params.delete('page');
    if (updateHistory) history.pushState({searchParams:params.toString()}, '', searchPath + '?' + params);
    let container = document.getElementById('ProductGridContainer');
    if (!container) {
      const main = document.querySelector('.template-search');
      if (!main) return;
      container = document.createElement('div'); container.id='ProductGridContainer'; container.className='product-grid-container';main.append(container);
    }
    container.setAttribute('aria-busy','true');
    if (!products.length) container.innerHTML = '<p role="status" class="page-width">Searching products…</p>';
    try {
      await loadCatalog();
      if (version !== sequence) return;
      const aside = ensureFilters(container);
      const queryMatches = products.filter(p => matchesQuery(p, params.get('q') || ''));
      let results = queryMatches.filter(p => matchesFilters(p, params));
      const sort = params.get('sort_by') || 'relevance';
      if (sort === 'price-ascending') results.sort((a,b) => a.price-b.price);
      if (sort === 'price-descending') results.sort((a,b) => b.price-a.price);
      if (sort === 'title-ascending') results.sort((a,b) => a.title.localeCompare(b.title));
      if (sort === 'created-descending') results.sort((a,b) => b.created-a.created);
      aside.querySelectorAll('input[type="checkbox"][name]').forEach(input => {
        input.checked = params.getAll(input.name).includes(input.value);
        input.disabled = !input.checked && !queryMatches.some(p => matchesFilters(p,params,input.name) && fieldValues(p,input.name).includes(input.value));
        input.closest('.facets__label')?.classList.toggle('active',input.checked);
        input.closest('.facets__label')?.classList.toggle('disabled',input.disabled);
      });
      aside.querySelectorAll('input[type="hidden"][name="q"]').forEach(input => input.value = params.get('q') || '');
      aside.querySelectorAll('input[name^="filter.v.price"]').forEach(input => input.value = params.get(input.name) || '');
      aside.querySelectorAll('price-range').forEach(range => {range.setMinAndMaxValues?.();range.syncSlidersFromInputs?.();});
      aside.querySelectorAll('select[name="sort_by"]').forEach(select => select.value = sort);
      aside.querySelectorAll('facet-remove a').forEach(link => { link.href = searchPath + '?q=' + encodeURIComponent(params.get('q') || ''); link.classList.remove('disabled'); });
      aside.querySelectorAll('.loading__spinner').forEach(el => el.classList.add('hidden'));
      const pages = Math.max(1,Math.ceil(results.length/24));
      const page = Math.min(pages,Math.max(1,Number(params.get('page')) || 1));
      const wrapper = document.createElement('div'); wrapper.className='template-search__results collection page-width';wrapper.id='product-grid';
      const count = document.createElement('p'); count.setAttribute('role','status');count.textContent = `${results.length} ${results.length === 1 ? 'product' : 'products'}`;wrapper.append(count);
      const grid = document.createElement('ul');grid.className='grid product-grid grid--2-col-tablet-down grid--4-col-desktop';grid.setAttribute('role','list');
      grid.innerHTML=results.slice((page-1)*24,page*24).map(p=>p.html).join('');wrapper.append(grid);
      if (!results.length) {const empty=document.createElement('p');empty.textContent='No products contain these keywords with the selected filters.';wrapper.append(empty);}
      if (pages>1) {const nav=document.createElement('nav');nav.setAttribute('aria-label','Search result pages'); for(let i=1;i<=pages;i++){const link=document.createElement('a');const next=new URLSearchParams(params);next.set('page',i);link.href=searchPath+'?'+next;link.dataset.substringPage='';link.textContent=String(i);link.style.marginInlineEnd='1.5rem';if(i===page)link.setAttribute('aria-current','page');nav.append(link);}wrapper.append(nav);}
      container.replaceChildren(wrapper);container.removeAttribute('aria-busy');
      document.querySelector('.template-search')?.classList.remove('template-search--empty');
      document.querySelectorAll('.template-search__header > p').forEach(el=>el.remove());
      document.querySelectorAll('input[type="search"][name="q"]').forEach(input=>input.value=params.get('q')||'');
    } catch(error) {
      if(version !== sequence)return;
      container.removeAttribute('aria-busy');container.innerHTML='<p role="alert" class="page-width">Could not load the product catalog. Please reload to try again.</p>';
    }
  }
  if (location.pathname === searchPath) {
    window.SpoiltSubstringSearch={render};
    const start=()=>render(location.search,null,false);
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
    document.addEventListener('submit',event=>{
      if(!(event.target instanceof HTMLFormElement))return;
      const form=event.target;const url=new URL(form.action,location.href);
      if(url.pathname!==searchPath || !form.querySelector('input[type="search"][name="q"]'))return;
      event.preventDefault();event.stopImmediatePropagation();render(paramsFromForm(form).toString(),event);
      document.querySelectorAll('predictive-search').forEach(instance=>{instance.substringRequest=(instance.substringRequest||0)+1;instance.close?.();});
    },true);
    document.addEventListener('click',event=>{const link=event.target.closest('[data-substring-page]');if(!link)return;event.preventDefault();render(new URL(link.href).search,null);});
  }
})();
